import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { Input } from "../../components/ui/input";
import logo from "../../assets/logo.png";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy relative overflow-hidden flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="grain-overlay" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-block bg-white rounded-xl p-3 shadow-lg ring-1 ring-gold/30">
            <img src={logo} alt="SVS College of Nursing" className="h-24 w-auto object-contain mx-auto" />
          </div>
          <h1 className="font-serif text-3xl text-sand mt-5">Admin Portal</h1>
          <p className="text-sand/50 text-sm mt-1">SVS College of Nursing</p>
        </div>
        <form onSubmit={submit} className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-[2px] p-8 space-y-5" data-testid="login-form">
          <div>
            <label className="text-sm text-sand/70">Email</label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-white/10 border-white/20 text-sand placeholder:text-sand/40"
              placeholder="admin@svsnursingcollege.com"
            />
          </div>
          <div>
            <label className="text-sm text-sand/70">Password</label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-white/10 border-white/20 text-sand placeholder:text-sand/40"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold text-navy font-bold px-6 py-3.5 transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <><Lock size={16} /> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
}
